export enum PremiseHazardPriorityType {
    unset,
    low,
    medium,
    high,
    critical
}
